

import MailTemplate from "../mail-template";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import GenericListTab from "./../../factories/generic-list-tab";
import InformationViewModel from "./../information";


//Available Veriables tab in MailTemplate View
class MailTemplateAvailableVariables extends GenericListTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.Selection([]);
        })
    }

    SaveAllowed: KnockoutObservable<boolean>;

    CustomFilter(): Models.HashObject[] {
        return [
            { Key: 'MailTemplateKey', Value: (<MailTemplate>this.Parent).MailTemplateKey() }
        ];
    }

    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }

    Save(item: Models.BaseModel2): JQueryPromise<void> {
        return $.Deferred<void>().resolve().promise();
    }

    Remove(itemIds: string[]): JQueryPromise<void> {
        return $.Deferred<void>().resolve().promise();
    }

    Commit(saveTime: string): JQueryPromise<void> {
        return $.Deferred<void>().resolve().promise();
    }

    Rollback(): JQueryPromise<void> {
        return $.Deferred<void>().resolve().promise();
    }

    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            var key = ko.unwrap(button.ActionKey);
            if (key === "MailTemplateAvailableVariablesSet") {
                button.Enabled(this.Selection() != null && this.Selection().length > 0);
            }
        });
    }

    CustomToolbarClick = (button: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(button.ActionKey);
        switch (key) {
            case 'MailTemplateAvailableVariablesSet':
                if (this.Selection() !== null) {
                    const value = this.Selection()[0]?.Key;
                    this.SetVariableInMailTemplate(value);
                }
                break;
        }
    }

    private SetVariableInMailTemplate(value: string) {
        if (value) {
            const mailTemplateViewModel = <MailTemplate>this.Parent;
            if (mailTemplateViewModel) {
                mailTemplateViewModel.SetVariable(value);
            }
        }
    }

}
export default MailTemplateAvailableVariables;